import { ReferralReportsState } from '@modules/reports/store/referral-reports.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ReferralReportsAdapter } from '../models/referral-reports-item';
import { ReferralCountByStageAdapter } from '../models/referral-count-by-stage';

export const getReferralReportsPageState =
  createFeatureSelector<ReferralReportsState>('referralReportsPage');

export const getReferralReportsPageIsLoaded = createSelector(
  getReferralReportsPageState,
  (state: ReferralReportsState) => !!state && state.loaded,
);

export const getReferralReportsPageIsLoading = createSelector(
  getReferralReportsPageState,
  (state: ReferralReportsState) => !!state && state.loading,
);

export const getReferralReportsPage = createSelector(
  getReferralReportsPageState,
  (state: ReferralReportsState) =>
    !!state && {
      ...state.referralReportsItems,
      content: state.referralReportsItems.content.map(
        (report) => new ReferralReportsAdapter(report),
      ),
    },
);

export const getJobFunctions = createSelector(
  getReferralReportsPageState,
  (state: ReferralReportsState) => !!state && state.jobFunctions,
);

export const getJobDepartments = createSelector(
  getReferralReportsPageState,
  (state: ReferralReportsState) => !!state && state.jobDepartments,
);

export const getReferralsByDepartment = createSelector(
  getReferralReportsPageState,
  (state: ReferralReportsState) => !!state && state.referralsByDepartment,
);

export const getReferralsByJobFunction = createSelector(
  getReferralReportsPageState,
  (state: ReferralReportsState) => !!state && state.referralsByJobFunction,
);

export const getReferralCountByStage = createSelector(
  getReferralReportsPageState,
  (state: ReferralReportsState) =>
    !!state && new ReferralCountByStageAdapter(state.reffalCountByStage),
);

export const getAllJobs = createSelector(
  getReferralReportsPageState,
  (state: ReferralReportsState) => !!state && state.allJobs,
);

export const selectAggregatedTotalDirectPerPhasesForGivenJobId = (jobId: number) =>
  createSelector(
    getReferralReportsPageState,
    (state: ReferralReportsState) =>
      !!state && state.allActiveJobsTotalDirectPerPhaseList.find((obj) => obj.jobId === jobId),
  );

export const AvgResponseTimeObj = {
  getAvgResponseTimeForJobId: (jobId: number) =>
    createSelector(
      getReferralReportsPageState,
      (state: ReferralReportsState) =>
        !!state &&
        state.averageResponseTime.find((resp) => resp.jobId === jobId)?.averageResponseTime,
    ),
};

export const getDashboardReportsSelect = createSelector(
  getReferralReportsPageState,
  (state: ReferralReportsState) => !!state && state.reportsDashboard,
);

export const getDashboardReportsSelectLoaded = createSelector(
  getReferralReportsPageState,
  (state: ReferralReportsState) => !!state && state.reportsDashboard.loadReportStatus.loaded,
);

export const getDashboardReportsSelectFail = createSelector(
  getReferralReportsPageState,
  (state: ReferralReportsState) => !!state && state.reportsDashboard.loadReportStatus.error,
);

export const getDashboardReportsSumissionSelect = createSelector(
  getReferralReportsPageState,
  (state: ReferralReportsState) => !!state && state.reportsDashboardSubmission,
);

export const getDashboardReportsSumissionSelectLoaded = createSelector(
  getReferralReportsPageState,
  (state: ReferralReportsState) =>
    !!state && state.reportsDashboardSubmission.loadReportStatus.loaded,
);

export const getDashboardReportsSumissionSelectFail = createSelector(
  getReferralReportsPageState,
  (state: ReferralReportsState) =>
    !!state && state.reportsDashboardSubmission.loadReportStatus.error,
);

export const getDashboardReportsOfferSelect = createSelector(
  getReferralReportsPageState,
  (state: ReferralReportsState) => !!state && state.reportsDashboardOffer,
);

export const getDashboardReportsOfferSelectLoaded = createSelector(
  getReferralReportsPageState,
  (state: ReferralReportsState) => !!state && state.reportsDashboardOffer.loadReportStatus.loaded,
);

export const getDashboardReportsOfferSelectFail = createSelector(
  getReferralReportsPageState,
  (state: ReferralReportsState) => !!state && state.reportsDashboardOffer.loadReportStatus.error,
);
export const getReferralOldestDate = createSelector(
  getReferralReportsPageState,
  (state: ReferralReportsState) => !!state && state.referralOldestDate,
);

export const getAveragesPerJob = createSelector(
  getReferralReportsPageState,
  (state: ReferralReportsState) => !!state && state.dashboardAveragesPerJob,
);

export const getSendEmailSent = createSelector(
  getReferralReportsPageState,
  (state: ReferralReportsState) => !!state && state.referralReportEmailSent,
);
